import { Alert, AlertIcon, Avatar, Badge, Box, Button, Flex, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, SimpleGrid, Stack, Stat, StatHelpText, StatLabel, StatNumber, Text } from '@chakra-ui/react';
import { DataTable, DeleteDialog, EmptyTable, LoadingTable } from '../../components';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import { FiChevronDown, FiUser } from 'react-icons/fi';
import React, { useEffect, useState } from 'react';
import { assignDriver, deleteVehicle, fetchDrivers, fetchVehicles, updateVehicleFleetType, updateVehicleStatus } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { vehicelType, vehicleDriverType } from '../../types';

import { AppDispatch } from '../../store';
import CountUp from 'react-countup';
import { GrRefresh } from 'react-icons/gr';
import { ToastContainer } from 'react-toastify';
import { createColumnHelper } from '@tanstack/react-table';
import { filterByStatus } from '../../utils';

export const ViewVehicles = () => {

    const [isOpen, setDeleteDialog] = useState<boolean>(false);
    const [statuses] = useState<Array<string>>(['parked', 'roaming', 'on delivery']);
    const [fleetTypes] = useState<Array<string>>(['bicycle', 'scooter', 'mini bakkie', 'bakkie', 'half truck', '4ton', '8ton', '12ton', 'van']);

    const { is_loading_vehicles, vehicles, vehicles_message, on_vehicle_delete, drivers } = useAppSelector(state => state.vehicleReducer);
    const { fleets } = useAppSelector(state => state.fleetReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const data: vehicelType[] = vehicles;

    const columnHelper = createColumnHelper<vehicelType | any>();

    const columns = [
        columnHelper.accessor('vehicle_id', {
            cell: (info) => info.getValue() ?? '-',
            header: 'Vehicle ID'
        }),
        columnHelper.accessor('make', {
            cell: (info) => <Text textTransform={'capitalize'}>{info.getValue() ?? '-'}</Text>,
            header: 'Make'
        }),
        columnHelper.accessor('model', {
            cell: (info) => <Text textTransform={'capitalize'}>{info.getValue() ?? '-'}</Text>,
            header: 'Model'
        }),
        columnHelper.accessor('year', {
            cell: (info) => info.getValue() ?? '-',
            header: 'Year'
        }),
        columnHelper.accessor('color', {
            cell: (info) => <Text textTransform={'capitalize'}>{info.getValue() ?? '-'}</Text>,
            header: 'Color',
        }),
        columnHelper.accessor('registration_number', {
            cell: (info) => <Text textTransform={'uppercase'}>{info.getValue() ?? '-'}</Text>,
            header: 'Registration',
        }),
        columnHelper.accessor('transmission', {
            cell: (info) => <Text textTransform={'capitalize'}>{info.getValue() ?? '-'}</Text>,
            header: 'Transmission',
        }),
        columnHelper.accessor('fuel_type', {
            cell: (info) => <Text textTransform={'capitalize'}>{info.getValue() ?? '-'}</Text>,
            header: 'Fuel Type',
        }),
        columnHelper.accessor('', {
            cell: ({ row }) => {
                const vehicle: vehicelType = row?.original;
                return (
                    <>
                        {
                            <HStack>
                                <Menu>
                                    <MenuButton
                                        as={IconButton}
                                        aria-label='Options'
                                        icon={
                                            <Avatar
                                                size='xs'
                                                name={vehicle?.driver_name}
                                            />}
                                        // bg={'transparent'}
                                        borderRadius={'50%'}
                                        style={{ height: '0px' }}
                                    />
                                    <MenuList>
                                        <MenuItem key={vehicle?._id} onClick={() => handleAssignDriver(`${vehicle?._id}`, '', '', vehicle)}>
                                            <HStack>
                                                <Stack p={1.5} bg={'#eeeeee'} borderRadius={'50%'}>
                                                    <FiUser style={{ width: 14, height: 14 }} />
                                                </Stack>
                                                <Text textTransform={'capitalize'}>Unassign</Text>
                                            </HStack>
                                        </MenuItem>
                                        {
                                            drivers?.map((driver: vehicleDriverType, index: number) => (
                                                <MenuItem key={index} onClick={() => handleAssignDriver(`${vehicle?._id}`, driver?.user_id, `${driver?.first_name} ${driver?.last_name}`, vehicle)}>
                                                    <HStack>
                                                        <Avatar
                                                            size='xs'
                                                            name={`${driver?.first_name} ${driver?.last_name}`}
                                                        />
                                                        <Text textTransform={'capitalize'}>{driver?.first_name} {driver?.last_name}</Text>
                                                    </HStack>
                                                </MenuItem>
                                            ))
                                        }
                                    </MenuList>
                                </Menu>
                                <Text textTransform={'capitalize'} style={{ marginLeft: '0rem' }}>{vehicle?.driver_name}</Text>
                            </HStack>
                            ||
                            <Menu>
                                <MenuButton
                                    as={IconButton}
                                    aria-label='Options'
                                    icon={<FiUser style={{ width: 20, height: 20 }} />}
                                    // bg={'transparent'}
                                    borderRadius={'50%'}
                                    p={2}
                                />
                                <MenuList>
                                    <MenuItem key={vehicle?._id} onClick={() => handleAssignDriver(`${vehicle?._id}`, '', '', vehicle)}>
                                        <HStack>
                                            <Stack p={1.5} bg={'#eeeeee'} borderRadius={'50%'}>
                                                <FiUser style={{ width: 14, height: 14 }} />
                                            </Stack>
                                            <Text textTransform={'capitalize'}>Unassigned</Text>
                                        </HStack>
                                    </MenuItem>
                                    {
                                        drivers?.map((driver: vehicleDriverType, index: number) => (
                                            <MenuItem key={index} onClick={() => handleAssignDriver(`${vehicle?._id}`, driver?.user_id, `${driver?.first_name} ${driver?.last_name}`, vehicle)}>
                                                <HStack>
                                                    <Avatar
                                                        size='xs'
                                                        name={`${driver?.first_name} ${driver?.last_name}`}
                                                    />
                                                    <Text textTransform={'capitalize'}>{driver?.first_name} {driver?.last_name}</Text>
                                                </HStack>
                                            </MenuItem>
                                        ))
                                    }
                                </MenuList>
                            </Menu>
                        }
                    </>
                );
            },
            header: 'Driver name',
        }),
        columnHelper.accessor('', {
            cell: ({ row }) => {
                const vehicle: vehicelType = row?.original;
                return (
                    <>
                        <Menu>
                            <MenuButton
                                as={IconButton}
                                aria-label='Options'
                                icon={
                                    <HStack bg={'#edf2f7'} borderWidth={1} borderColor={'gray.300'}>
                                        <Badge py={1} colorScheme={'gray'} px={2} borderRadius={3}>{vehicle?.fleet_type || 'Unassigned'}</Badge>
                                        <FiChevronDown style={{ paddingRight: 3 }} />
                                    </HStack>
                                }
                                variant='outline'
                                style={{ height: '0px' }}
                            />
                            <MenuList>
                                {
                                    fleetTypes?.map((fleet_type, index) => (
                                        <MenuItem key={index} textTransform={'capitalize'} onClick={() => handleUpdateVehicleFleetType(`${vehicle?.vehicle_id}`, fleet_type)}>
                                            {fleet_type}
                                        </MenuItem>
                                    ))
                                }
                            </MenuList>
                        </Menu>
                    </>
                );
            },
            header: 'Fleet Type',
        }),
        columnHelper.accessor('', {
            cell: ({ row }) => {
                const vehicle: vehicelType = row?.original;
                return (
                    <>
                        <Menu>
                            <MenuButton
                                disabled={!vehicle?.driver_id}
                                as={IconButton}
                                aria-label='Options'
                                icon={
                                    <HStack bg={vehicle?.status === 'on delivery' ? '#c6f4d2' : vehicle?.status === 'parked' ? '#fefcbf' : '#edf2f7'}>
                                        <Badge py={1} colorScheme={vehicle?.status === 'on delivery' ? 'green' : vehicle?.status === 'parked' ? 'yellow' : 'gray'} px={2} borderRadius={3}>{vehicle?.status}</Badge>
                                        <FiChevronDown style={{ paddingRight: 3 }} />
                                    </HStack>
                                }
                                variant='outline'
                                style={{ height: '0px' }}
                            />
                            <MenuList>
                                {
                                    statuses?.map((status, index) => (
                                        <MenuItem key={index} textTransform={'capitalize'} onClick={() => handleUpdateStatus(`${vehicle?._id}`, status, vehicle)}>
                                            {status}
                                        </MenuItem>
                                    ))
                                }
                            </MenuList>
                        </Menu>
                    </>
                );
            },
            header: 'Status',
        }),
        columnHelper.accessor('', {
            cell: ({ row }) => {
                const vehicle: vehicelType = row?.original;
                return (
                    <>
                        <HStack>
                            <Button colorScheme={'teal'} size='xs' variant={'outline'} onClick={() => navigate(`/vehicles/${vehicle?.vehicle_id}/edit`)}>
                                Edit
                            </Button>
                            <Button colorScheme={'red'} size='xs' variant={'outline'} onClick={() => setDeleteDialog(!isOpen)}>
                                {on_vehicle_delete ? '...' : 'Delete'}
                            </Button>
                        </HStack>
                        <DeleteDialog
                            id={`${vehicle?._id}`}
                            item='Vehicle'
                            isOpen={isOpen}
                            onDelete={() => handleDeleteVehicle(`${vehicle._id}`)}
                            onClose={() => setDeleteDialog(!isOpen)}
                        />
                    </>
                );
            },
            header: 'Actions',
        })
    ];

    const handleRefresh = () => {
        dispatch(fetchVehicles());
        dispatch(fetchDrivers());
    };

    const handleAssignDriver = (id: string, driver_id: string, driver_name: string, values: vehicelType) => {
        const newValues: vehicelType = { ...values, driver_id, driver_name };
        dispatch(assignDriver(id, newValues));
    };

    const handleUpdateStatus = (id: string, status: string, values: vehicelType) => {
        const newValues: vehicelType = { ...values, status };
        dispatch(updateVehicleStatus(id, newValues));
    };

    const handleUpdateVehicleFleetType = async (vehicle_id: string, fleet_type: string) => {
        await dispatch(updateVehicleFleetType({
            vehicle_id,
            fleet_type
        }));
    };

    const handleDeleteVehicle = (id: string) => {
        dispatch(deleteVehicle(id));
        setDeleteDialog(!isOpen);
    };

    useEffect(() => {
        if (!vehicles.length) dispatch(fetchVehicles());
        if (!drivers.length) dispatch(fetchDrivers());
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                pt={2}
                pb={10}
            >
                <Stack>
                    <Stack mb={4}>
                        <SimpleGrid columns={[1, 1, 2, 3]} spacing={6}>
                            <Stat bgColor={'white'} px={4} py={3} borderRadius={6}>
                                <StatLabel textTransform={'uppercase'} color={'gray.500'} fontSize={'xs'} fontWeight={'medium'}>Packed vehicles</StatLabel>
                                <HStack>
                                    <CountUp start={0} end={filterByStatus(vehicles, 'parked').length || 0} duration={2}>
                                        {
                                            ({ countUpRef }) => (
                                                <StatNumber fontSize={'4xl'}><span ref={countUpRef}>{filterByStatus(vehicles, 'parked').length || 0}</span><Text fontSize={'18px'} color={'#bdbdbd'} display={'inline'}>/{vehicles?.length}</Text></StatNumber>
                                            )
                                        }
                                    </CountUp>
                                </HStack>
                                <StatHelpText color={'gray.500'} fontSize={'xs'}>Company vehicles that are available.</StatHelpText>
                            </Stat>
                            <Stat bgColor={'white'} px={4} py={3} borderRadius={6}>
                                <StatLabel textTransform={'uppercase'} color={'gray.500'} fontSize={'xs'} fontWeight={'medium'}>Roaming vehicles</StatLabel>
                                <HStack>
                                    <CountUp start={0} end={filterByStatus(vehicles, 'roaming').length || 0} duration={2}>
                                        {
                                            ({ countUpRef }) => (
                                                <StatNumber fontSize={'4xl'}><span ref={countUpRef}>{filterByStatus(vehicles, 'roaming').length || 0}</span><Text fontSize={'18px'} color={'#bdbdbd'} display={'inline'}>/{vehicles?.length}</Text></StatNumber>
                                            )
                                        }
                                    </CountUp>
                                </HStack>
                                <StatHelpText color={'gray.500'} fontSize={'xs'}>Company vehicles that are on the road, but no delivery.</StatHelpText>
                            </Stat>
                            <Stat bgColor={'white'} px={4} py={3} borderRadius={6}>
                                <StatLabel textTransform={'uppercase'} color={'gray.500'} fontSize={'xs'} fontWeight={'medium'}>On Delivery vehicles</StatLabel>
                                <HStack>
                                    <CountUp start={0} end={filterByStatus(vehicles, 'on delivery').length || 0} duration={2}>
                                        {
                                            ({ countUpRef }) => (
                                                <StatNumber fontSize={'4xl'}><span ref={countUpRef}>{filterByStatus(vehicles, 'on delivery').length || 0}</span><Text fontSize={'18px'} color={'#bdbdbd'} display={'inline'}>/{vehicles?.length}</Text></StatNumber>
                                            )
                                        }
                                    </CountUp>
                                </HStack>
                                <StatHelpText color={'gray.500'} fontSize={'xs'}>Company vehicles that are busy with delivery.</StatHelpText>
                            </Stat>
                        </SimpleGrid>
                    </Stack>
                    <Stack bg={'#FFFFFF'} p={4} borderRadius={6}>
                        <HStack justifyContent={'space-between'} mb={4} px={2}>
                            <Text fontSize={'lg'} fontWeight={'medium'}>Vehicles Table</Text>
                            <HStack>
                                <IconButton aria-label='Refresh button' size={'sm'} icon={<GrRefresh className={`${is_loading_vehicles ? 'loading-refresh-icon' : ''}`} />} onClick={handleRefresh} />
                                <Button colorScheme={'gray'} size='sm' as={DefaultLink} to='/vehicles/fleets'>
                                    Manage Fleets
                                    <Badge ml={1} variant='solid' colorScheme='green'>
                                        {fleets?.length}
                                    </Badge>
                                </Button>
                                <Button bg={'#ffca28'} size='sm' as={DefaultLink} to='/vehicles/add'>
                                    Add Vehicle
                                </Button>
                            </HStack>
                        </HStack>
                        <SimpleGrid columns={[1, null, 1]} spacing='40px'>
                            <Box w='100%'>
                                {
                                    vehicles_message &&
                                    <Alert status='error' borderRadius={4} mb={3}>
                                        <AlertIcon />
                                        {vehicles_message}
                                    </Alert>
                                }
                                <DataTable columns={columns} data={data} variant='striped' />
                                {is_loading_vehicles && !vehicles.length && <LoadingTable />}
                                {!vehicles.length && !is_loading_vehicles && <EmptyTable title='Oops!' description='Your company does not have vehicles.' />}
                            </Box>
                        </SimpleGrid>
                    </Stack>
                    <ToastContainer />
                </Stack>
            </Flex>
        </>
    );
};